// extracted by mini-css-extract-plugin
export var autocomplete = "on-page-search-module--autocomplete--729c5";
export var formActions = "on-page-search-module--formActions--32ba7";
export var formError = "on-page-search-module--formError--eab57";
export var formItem = "on-page-search-module--formItem--e9a9a";
export var formPanel = "on-page-search-module--formPanel--6930a";
export var formPanelContent = "on-page-search-module--formPanelContent--a2ec3";
export var onPageSearch = "on-page-search-module--onPageSearch--c131f";